import authenticated from '../http-clients/authenticated'

export default{
  index({tenantId, topicId, componentId}){
    const url = topicId ? `/tenants/${tenantId}/topics/${topicId}/kc` : `tenants/${tenantId}/components/${componentId}/knowledgechecks`

    return authenticated({
      url: url,
      method: 'get'
    })
  },
  show({tenantId, knowledgecheckId}){
    return authenticated({
      url: `/tenants/${tenantId}/knowledgechecks/${knowledgecheckId}`,
      method: 'get'
    })
  },
  store({tenantId, topicId, componentId, data}){
    const url = topicId ? `/tenants/${tenantId}/topics/${topicId}/kc` : `tenants/${tenantId}/components/${componentId}/knowledgechecks`

    return authenticated({
      url: url,
      method: 'post',
      data
    })
  },
  update({tenantId, knowledgecheckId, data}){
    return authenticated({
      url: `/tenants/${tenantId}/knowledgechecks/${knowledgecheckId}`,
      method: 'put',
      data
    })
  },
  destroy({tenantId,  knowledgecheckId}){
    return authenticated({
      url: `/tenants/${tenantId}/knowledgechecks/${knowledgecheckId}`,
      method: 'delete'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/knowledgechecks/knowledgecheck.js